var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ce-anchor-element"},[_c('a',{attrs:{"id":_vm.objectdata.cssID[0]}}),(_vm.objectdata.showheadline)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.getHeadline(_vm.objectdata.headline.unit, _vm.objectdata.headline.value))}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }